import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ReactiveFormsModule,
  SelectControlValueAccessor,
} from '@angular/forms';

import {
  FORM_BASE_CONTROL_CMP,
  FormBaseControlComponent,
  FormBaseControlStyleDirective,
} from '@plugins/client/forms/form';
import { TranslatePipe } from '@plugins/client/translate/pipes';

@Component({
  selector: 'plugins-select',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormBaseControlStyleDirective,
    TranslatePipe,
  ],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  providers: [
    {
      provide: FORM_BASE_CONTROL_CMP,
      // eslint-disable-next-line @angular-eslint/no-forward-ref
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent extends FormBaseControlComponent {
  @Input() showDefault = true;
  @Input() defaultOptionLabel?: string;
  @Input() compareWith: (o1: unknown, o2: unknown) => boolean = (o1, o2) =>
    o1 === o2;

  @ViewChild(SelectControlValueAccessor, { static: true })
  select!: SelectControlValueAccessor;
}
